// extracted by mini-css-extract-plugin
module.exports = {"header":"ManualTimeModal_header__3TrMm","content":"ManualTimeModal_content__2UjA0"};